import { useStoreon } from "storeon/react";
import { IEligibilityStore, IEligibilityEvents } from "../store/eligibilityStore";

export const useEligibilityStore = () => {
  const {
    dispatch: eligibilityDispatch,
    eligibilityStore
  } = useStoreon<IEligibilityStore, IEligibilityEvents>("eligibilityStore");

  return {eligibilityDispatch, eligibilityStore}
};